import { Injectable } from '@angular/core';
import { StartPoint } from '../models/start-point.model';
import { jsonHeaders } from './csrf';

export interface TripState {
  id: string;              // guid
  name: string;            // never null (backend guarantees)
  stop_ids: number[];
  start: StartPoint | null;
}

@Injectable({ providedIn: 'root' })
export class TripsService {
  // POST /api/v1/trips with empty body — backend reads session state and creates
  // a DB Trip. Used by "Save plan" click while logged-in. Returns the new trip.
  async createFromSession(): Promise<TripState> {
    const res = await fetch('/api/v1/trips', {
      method: 'POST',
      headers: jsonHeaders(),
      credentials: 'same-origin',
      body: '{}',
    });
    if (!res.ok) throw new Error(`trips POST failed: HTTP ${res.status}`);
    return (await res.json()) as TripState;
  }

  async fetch(guid: string): Promise<TripState> {
    const res = await fetch(`/api/v1/trips/${guid}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error(`trips GET failed: HTTP ${res.status}`);
    return (await res.json()) as TripState;
  }

  async update(
    guid: string,
    payload: { stop_ids?: number[]; name?: string | null; start?: StartPoint | null }
  ): Promise<TripState> {
    const res = await fetch(`/api/v1/trips/${guid}`, {
      method: 'PATCH',
      headers: jsonHeaders(),
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`trips PATCH failed: HTTP ${res.status}`);
    return (await res.json()) as TripState;
  }
}
